import { useCallback, useEffect } from 'react';
import { useSafePathname, useSafeSegments } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const useRouteObserver = (params: Params) => {
  const { onChange } = params;

  const pathname = useSafePathname();
  const segments = useSafeSegments();

  const viewKey = segments?.join('/') ?? '';

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleRouteChange = useCallback(() => {
    if (!pathname || !segments) return;

    onChange({ pathname, viewKey, segments });
  }, [onChange, pathname, viewKey, segments]);

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(handleRouteChange, [handleRouteChange]);

  // ─────────────────────────────────────────────────────────────────────

  return { pathname, viewKey, segments };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  onChange: (route: RouteInfo) => void;
};

export type RouteInfo = {
  pathname: string;
  viewKey: string;
  segments: string[];
};
